import React from 'react';
import { css } from '@emotion/react';
import { halfSpacing } from 'styles/global_defaults/scaffolding';

const styles = css`
  gap: ${halfSpacing}px;
`;

const NpsCsatStatWrapper = ({ children }: { children: React.ReactNode }) => (
  <div css={styles} className='d-flex justify-content-between'>
    {children}
  </div>
);

export default NpsCsatStatWrapper;
